/* Curated Unsplash still-photo fallbacks for the Trip Cover Chooser.
   Shown when the live /unsplash/search proxy is quota-throttled so the
   picker never disappears on a member. All URLs are Unsplash CDN hotlinks
   with UTM tracking + required attribution baked into the returned object. */

const _utm = "?utm_source=travelerpulse&utm_medium=referral";

/** @type {Array<{id:string, url_regular:string, url_small:string, photographer:string, photographer_url:string, unsplash_url:string, download_location:null, alt:string, tag:string}>} */
export const CURATED_COVERS = [
  {
    id: "curated-beach",
    url_regular: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1080&auto=format&fit=crop&q=80",
    url_small:   "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&auto=format&fit=crop&q=80",
    photographer: "Sean O.",
    photographer_url: "https://unsplash.com/@seaan" + _utm,
    unsplash_url: "https://unsplash.com" + _utm,
    download_location: null,
    alt: "Turquoise beach with clear water",
    tag: "Beach",
  },
  {
    id: "curated-mountain",
    url_regular: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1080&auto=format&fit=crop&q=80",
    url_small:   "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=400&auto=format&fit=crop&q=80",
    photographer: "Krzysztof Kowalik",
    photographer_url: "https://unsplash.com/@krkow" + _utm,
    unsplash_url: "https://unsplash.com" + _utm,
    download_location: null,
    alt: "Alpine mountain range at sunrise",
    tag: "Mountain",
  },
  {
    id: "curated-city",
    url_regular: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1080&auto=format&fit=crop&q=80",
    url_small:   "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=400&auto=format&fit=crop&q=80",
    photographer: "Anders Jildén",
    photographer_url: "https://unsplash.com/@andersjilden" + _utm,
    unsplash_url: "https://unsplash.com" + _utm,
    download_location: null,
    alt: "City skyline at dusk",
    tag: "City",
  },
  {
    id: "curated-desert",
    url_regular: "https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=1080&auto=format&fit=crop&q=80",
    url_small:   "https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=400&auto=format&fit=crop&q=80",
    photographer: "Jeremy Bishop",
    photographer_url: "https://unsplash.com/@jeremybishop" + _utm,
    unsplash_url: "https://unsplash.com" + _utm,
    download_location: null,
    alt: "Golden desert dunes",
    tag: "Desert",
  },
  {
    id: "curated-forest",
    url_regular: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1080&auto=format&fit=crop&q=80",
    url_small:   "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&auto=format&fit=crop&q=80",
    photographer: "Sergei A",
    photographer_url: "https://unsplash.com/@sakulich" + _utm,
    unsplash_url: "https://unsplash.com" + _utm,
    download_location: null,
    alt: "Sunlight through a forest canopy",
    tag: "Forest",
  },
  {
    id: "curated-road",
    url_regular: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1080&auto=format&fit=crop&q=80",
    url_small:   "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=400&auto=format&fit=crop&q=80",
    photographer: "Jamie Street",
    photographer_url: "https://unsplash.com/@jamie452" + _utm,
    unsplash_url: "https://unsplash.com" + _utm,
    download_location: null,
    alt: "Empty highway curving into the horizon",
    tag: "Road trip",
  },
];

/** Pick 3 curated covers, seeded by the query so the same trip always gets
    the same fallback trio (feels like a real suggestion instead of noise). */
export function curatedFor(query) {
  const q = (query || "").toLowerCase();
  const seed = q.split("").reduce((a, c) => a + c.charCodeAt(0), 0) || 1;
  const rotated = [...CURATED_COVERS.slice(seed % CURATED_COVERS.length), ...CURATED_COVERS.slice(0, seed % CURATED_COVERS.length)];
  return rotated.slice(0, 3);
}
